import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import {
    DASHBOARD_REQUESTS_RESOURCE,
    DASHBOARD_RETURNS_RESOURCE,
    DASHBOARD_TICKETS_SUMMARY_RESOURCE
} from '@app/dashboard/mocks/dashboard.data';

@Injectable()
export class DashboardMockInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.shouldHandle(req) || req.method !== 'GET') {
            return next.handle(req);
        }

        if (/\/dashboard\/requests\/?$/.test(req.url)) {
            return this.response(DASHBOARD_REQUESTS_RESOURCE);
        }

        if (/\/dashboard\/returns\/?$/.test(req.url)) {
            return this.response(DASHBOARD_RETURNS_RESOURCE);
        }

        if (/\/dashboard\/tickets\/summary\/?$/.test(req.url)) {
            return this.response(DASHBOARD_TICKETS_SUMMARY_RESOURCE);
        }

        return next.handle(req);
    }

    private shouldHandle(req: HttpRequest<any>): boolean {
        return req.url.includes('/dashboard/');
    }

    private response(body: any): Observable<HttpEvent<any>> {
        return of(new HttpResponse({ status: 200, body })).pipe(delay(250));
    }
}
